import { Button } from '@bambi/component-library/src/components/Button/Button';
import { datadogLogs } from '@datadog/browser-logs';
import { useEffect } from 'react';

import { authService } from './authService';
import type { UserProfileRead } from 'src/common/external/bambi-api/bambiApi';
import { Logo } from 'src/common/Logo';

// Shown when a signed-in user's profile has no organization memberships.
// Previously selectCurrentOrganization threw here and blanked the app.
export function NoOrganizationNotice({
  profile,
}: {
  profile: UserProfileRead;
}) {
  useEffect(() => {
    // Handled gracefully, but it shouldn't happen — log for investigation.
    datadogLogs.logger.error('AuthProvider: Profile has no memberships!', {
      auth: { userId: profile.id, email: profile.email },
    });
  }, [profile.id, profile.email]);

  return (
    <div className="flex h-[100vh] w-[100vw] items-center justify-center">
      <div className="m-16 w-full max-w-lg rounded-lg border border-gray-200 text-center shadow-sm">
        <div className="m-16">
          <div className="mx-auto flex justify-center">
            <Logo />
          </div>
          <h4 className="mt-3 text-lg text-gray-700">No organization</h4>
          <p className="text-gray-500" data-testid="no-organization-notice">
            Your account isn&rsquo;t assigned to an organization yet. Contact
            your administrator to be added, then sign in again.
          </p>
          <div className="mt-4">
            <Button
              dataTestId="sign-out-button"
              variant="secondary"
              onClick={authService.signOut}
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
